export enum PaymentMethod {
  OneClick = "OneClick",
  GPay = "GPay",
  ApplePay = "ApplePay",
}

export const paymentCBType = {
  success: "success",
  decline: "decline",
  redirect: "redirect",
};

export const paymentDeclineReason = {
  PERMANENT_CARD_BLOCK: 1,
  INTERNAL_CARD_BLOCK: 2,
  GENERAL: 3,
  INSUFFICIENT_FUNDS: 4,
  CUSTOMER_ABORT: 5,
  AUTH_3D_FAIL: 6,
  INVALID_CARD_DATA: 7,
};

export const DISCOUNT_PERCENT = 1;
export const DISCOUNT_MONEY = 2;

export const INITIAL_OFFER_DISCOUNT = 1;
export const REGULAR_PRICE_DISCOUNT = 2;
export const ONE_TIME_OFFER_DISCOUNT = 3;
export const HAPPY_BIRTHDAY_DISCOUNT = 4;

export const RISK_JS_INTEGRITY_DEV =
  "sha384-fOaCPIhHNNFNHXHKks9iDyZiQKz4PCq/SIA9+IM4+ApcYI0bxLL+BVyabmiOLtJj";
export const RISK_JS_INTEGRITY_PROD =
  "sha384-JS/Q0U1PlEbjK05xn23jCiI9IGUnrXO4HmTcz+sEA6z+n4qfKYfPIzm1Knev67+G";

export const APPLE_PAY_SDK_URL =
  "https://applepay.cdn-apple.com/jsapi/1.latest/apple-pay-sdk.js";

export const sitesWithRiskJs = [
  "amourlee",
  "quickmedates",
  "amourforme",
  "asianforme",
  "latinmelodies",
  "cupidlee",
  "cupidticket",
  "interchatify",
  "minglechats",
];
